(() => {
    if (window.__bnbGlobalSiblingDedupBound) return;
    window.__bnbGlobalSiblingDedupBound = true;

    const productPath = (href) => {
      if (!href) return '';
      try {
        return new URL(href, window.location.origin).pathname.replace(/\/$/, '');
      } catch (error) {
        return '';
      }
    };

    const cardShell = (productCard) =>
      productCard.closest(
        '#ProductsList .f-column.card, .bnb-collection-tabs__item, .swiper-slide, .slider__slide, .splide__slide, .grid__item, .product-grid__item'
      ) || productCard;

    const hideDuplicateSiblingCards = () => {
      const groupsByScope = new Map();

      document.querySelectorAll('[data-bnb-global-card]').forEach((productCard) => {
        const shell = cardShell(productCard);

        if (shell.hasAttribute('data-bnb-sibling-duplicate-hidden')) {
          shell.removeAttribute('data-bnb-sibling-duplicate-hidden');
          shell.style.removeProperty('display');
        }

        const siblingLinks = [...productCard.querySelectorAll('.bnb-card-siblings__item[href]')];
        if (siblingLinks.length < 2) return;

        const siblingPaths = siblingLinks
          .map((link) => productPath(link.getAttribute('href')))
          .filter(Boolean);
        const currentPath = productPath(
          productCard.getAttribute('data-bnb-card-url') ||
          productCard.querySelector('.bnb-global-card__overlay[href]')?.getAttribute('href')
        );

        if (!currentPath || siblingPaths.length < 2) return;

        const groupKey = [...new Set(siblingPaths)].sort().join('|');
        const scope = shell.parentElement || document.body;

        if (!groupsByScope.has(scope)) groupsByScope.set(scope, new Map());
        const scopeGroups = groupsByScope.get(scope);
        if (!scopeGroups.has(groupKey)) scopeGroups.set(groupKey, []);

        scopeGroups.get(groupKey).push({
          shell,
          currentPath,
          canonicalPath: siblingPaths[0],
        });
      });

      groupsByScope.forEach((scopeGroups) => {
        scopeGroups.forEach((entries) => {
          if (entries.length < 2) return;

          const keeper =
            entries.find((entry) => entry.currentPath === entry.canonicalPath) ||
            entries[0];

          entries.forEach((entry) => {
            if (entry === keeper) return;
            entry.shell.setAttribute('data-bnb-sibling-duplicate-hidden', 'true');
            entry.shell.style.setProperty('display', 'none', 'important');
          });
        });
      });
    };

    let dedupeTimer;
    const scheduleDedupe = () => {
      window.clearTimeout(dedupeTimer);
      dedupeTimer = window.setTimeout(hideDuplicateSiblingCards, 40);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleDedupe, { once: true });
    } else {
      scheduleDedupe();
    }

    new MutationObserver(scheduleDedupe).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  })();
